export default {
    data() {
        return {
            weightEditingMap: {},
            lastIsWeightEditing: false,
        }
    },
    methods: {
        onWeightEditing(payload) {
            if (!payload || !payload.key) {
                return
            }
            if (payload.isEditing) {
                this.$set(this.weightEditingMap, payload.key, true)
            } else {
                this.$delete(this.weightEditingMap, payload.key)
            }
            const current = this.isWeightEditing()
            if (current !== this.lastIsWeightEditing) {
                this.lastIsWeightEditing = current
                this.emitEditingChange(current)
            }
        },
        isWeightEditing() {
            return this.weightEditingMap && Object.keys(this.weightEditingMap).length > 0
        },
        resetWeightEditing() {
            this.weightEditingMap = {}
            this.lastIsWeightEditing = false
        },
        emitEditingChange(isWeightEditing) {
            if (typeof this.buildPayloadDeclarations !== 'function') {
                return
            }
            const hasUnfilledRows = typeof this.hasUnfilledRows === 'function'
                ? this.hasUnfilledRows(this.declarations)
                : false
            this.$emit('editing-change', {
                dirty: this.dirty,
                isWeightEditing,
                hasUnfilledRows,
                declarations: this.buildPayloadDeclarations(),
            })
        },
    },
}
